module.exports = __webpack_public_path__ + "img/08_1_2_3.f17c27ee.png";